module.exports = __webpack_public_path__ + "img/blockables-instructions-2.76669ee0.png";